
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/imoveis",
      function () {
        return require("private-next-pages/imoveis/index.js");
      }
    ]);
  